module.exports = __webpack_public_path__ + "static/media/Walking – 1.20875c54.jpg";